import { Injectable } from '@angular/core';
import { BaseMapper } from '@shared/data';
import { ContractorPublicDto, ContractorsPublicSearchResultDto } from '../dto';
import { ContractorBookingModel, ContractorsBookingModel } from '../model';

@Injectable({
    providedIn: 'root',
})
export class ContractorsBookingMapper extends BaseMapper<ContractorsBookingModel, ContractorsPublicSearchResultDto> {
    public mapDtoToModel(dto: ContractorsPublicSearchResultDto): ContractorsBookingModel {
        return {
            contractors: dto.contractors.map(this.mapContractorDtoToModel.bind(this)),
        };
    }

    private mapContractorDtoToModel(dto: ContractorPublicDto): ContractorBookingModel {
        return {
            uuid: dto.uuid,
            name: dto.name,
            address: dto.address,
            post: dto.post,
            postNumber: dto.postNumber,
            email: dto.email,
            phone: dto.phone,
        };
    }
}
